import Emergencies from './EmergenciesPage';

export default Emergencies;
